/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ capabilities: NonNullable<unknown>, facts: NonNullable<unknown> }} Directory_Knowledge_SummaryInputs */

const en_directory_knowledge_summary = /** @type {(inputs: Directory_Knowledge_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.capabilities} capabilities · ${i?.facts} verified facts`)
};

const zh_directory_knowledge_summary = /** @type {(inputs: Directory_Knowledge_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.capabilities} 项能力 · ${i?.facts} 项已验证事实`)
};

/**
* | output |
* | --- |
* | "{capabilities} capabilities · {facts} verified facts" |
*
* @param {Directory_Knowledge_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_summary = /** @type {((inputs: Directory_Knowledge_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_summary(inputs)
	return zh_directory_knowledge_summary(inputs)
});
export { directory_knowledge_summary as "directory.knowledge.summary" }